import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['storefrontForm', 'ownerGroupSelect', 'ownerSelect', 'slug', 'destinationsSelect', 'deliveryBool', 'destinationSearchBool']
  static values = { destinationSelectionOption: String }

  connect() {
    this.formDirty = false
    this.updateSelectedDestinations()
    if (this.ownerGroupSelectTarget.value !== '') {
      this.updateSlug()
    }
  }

  ownerGroupSelectChanged() {
    this.updateSlug()
  }

  leavingPage(event) {
    if (this.formDirty) {
      event.preventDefault();
    }
  }

  formChanged() {
    if (this.formDirty === false) {
      window.addEventListener('beforeunload', event => {
        this.leavingPage(event)
      })
    }
    this.formDirty = true;
  }

  formSubmitted() {
    this.ownerSelectTarget.removeAttribute('disabled'); // Remove the disabled attribute
    this.formDirty = false;
    window.removeEventListener('beforeunload', event => {
      this.leavingPage(event);
    });
  }

  updateSlug() {
    if (this.slugTarget.value === '') {
      const slugs = JSON.parse(this.ownerGroupSelectTarget.dataset.slugs)
      const selectedOwner = this.ownerGroupSelectTarget.value
      this.slugTarget.value = slugs[selectedOwner]
    }
  }

  updateSelectedDestinations() {
    const destinationsSelect = this.destinationsSelectTarget
    if ('selectedOptions' in destinationsSelect.dataset) {
      const selectedDestinations = JSON.parse(destinationsSelect.dataset.selectedOptions)
      let options = ''
      selectedDestinations.forEach(arr => {
        options = `${options}${this.buildOption(arr)}`
      })
      if (options !== '') {
        destinationsSelect.innerHTML = options
      }
    }
  }

  buildOption(arr) {
    return `<option value="${arr[0]}" selected="selected">${arr[1]}</option>`
  }

  destinationSelectionOptionValueChanged() {
    switch (this.destinationSelectionOptionValue) {
    case 'both':
      this.destinationSearchBoolTarget.value = 'true'
      this.deliveryBoolTarget.value = 'true'
      return
    case 'destination':
      this.destinationSearchBoolTarget.value = 'true'
      this.deliveryBoolTarget.value = 'false'
      return
    case 'address':
      this.destinationSearchBoolTarget.value = 'false'
      this.deliveryBoolTarget.value = 'true'
      return
    }
  }

  destinationSelectionOptionChanged(event) {
    this.destinationSelectionOptionValue = event.target.value
  }
}
